var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComunicadosAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.006,
    height: 24.006,
    viewBox: "0 0 24.006 24.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_543",
    "data-name": "Grupo 543",
    transform: "translate(-167.5 -746)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_275",
    "data-name": "Rect\\xE1ngulo 275",
    width: 24.006,
    height: 24.006,
    transform: "translate(167.5 746)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "campaign_FILL0_wght300_GRAD0_opsz40",
    d: "M114.338-763.779h-2.1a.57.57,0,0,1-.421-.17.575.575,0,0,1-.169-.423.566.566,0,0,1,.169-.42.575.575,0,0,1,.421-.168h2.1a.57.57,0,0,1,.421.17.575.575,0,0,1,.169.423.566.566,0,0,1-.169.42A.575.575,0,0,1,114.338-763.779Zm-3.875,4a.608.608,0,0,1,.389-.235.565.565,0,0,1,.442.118l1.684,1.261a.6.6,0,0,1,.241.389.548.548,0,0,1-.118.436.6.6,0,0,1-.392.241.553.553,0,0,1-.439-.117l-1.69-1.261a.607.607,0,0,1-.235-.389A.565.565,0,0,1,110.463-759.78Zm2.479-10.359-1.649,1.252a.565.565,0,0,1-.442.117.6.6,0,0,1-.389-.241.536.536,0,0,1-.117-.433.608.608,0,0,1,.235-.392l1.655-1.252a.552.552,0,0,1,.439-.118.6.6,0,0,1,.392.241.537.537,0,0,1,.117.434A.6.6,0,0,1,112.942-770.139ZM99.7-761.948h-1.3a1.415,1.415,0,0,1-1.037-.433,1.415,1.415,0,0,1-.433-1.037v-1.9a1.415,1.415,0,0,1,.433-1.037,1.415,1.415,0,0,1,1.037-.433h3.862l3.107-1.853a.675.675,0,0,1,.735-.005.694.694,0,0,1,.37.639v7.284a.694.694,0,0,1-.37.639.676.676,0,0,1-.735-.006l-3.107-1.853h-1.38v3.079a.57.57,0,0,1-.17.421.575.575,0,0,1-.423.169.566.566,0,0,1-.42-.169.575.575,0,0,1-.168-.421Zm5.592.421v-5.686l-2.71,1.6H98.394a.276.276,0,0,0-.2.09.276.276,0,0,0-.09.2v1.9a.277.277,0,0,0,.09.2.277.277,0,0,0,.2.09h4.183Zm2.483.089V-767.3a3.7,3.7,0,0,1,.891,1.262,4.068,4.068,0,0,1,.338,1.67,4.068,4.068,0,0,1-.338,1.67A3.7,3.7,0,0,1,107.77-761.438ZM101.7-764.37Z",
    transform: "translate(73.577 1522.391)",
    fill: "#00bdd9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunicadosAzul);
export default __webpack_public_path__ + "static/media/comunicados_azul.dccd7469677eda760ffa1fca1315c816.svg";
export { ForwardRef as ReactComponent };